import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { MenuItem } from '@material-ui/core';

var DropdownItem = function DropdownItem(_ref) {
  var children = _ref.children,
      dsOnClick = _ref.dsOnClick,
      e2e = _ref.e2e,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    onClick: dsOnClick
  }, e2e && {
    'data-e2e': e2e
  }), children, label);
};

export default DropdownItem;

try {
  DropdownItem.__docgenInfo = {
    description: '',
    displayName: 'DropdownItem',
    methods: [],
    props: {
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      dsOnClick: {
        defaultValue: null,
        description: '',
        name: 'dsOnClick',
        required: true,
        type: {
          name: 'MouseEventHandler<HTMLLIElement>'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map